// src/hooks/useDepots.ts
import { useQuery } from "@tanstack/react-query";
import api from "../api"; // your axios instance

export interface Depot {
  pikitup_depot_id: number;
  depot_name: string;
  depot_suburb: string | null;
  status_flg: number;
}

interface DepotsResponse {
  statusCode: number;
  message: string;
  data: {
    depots: Depot[];
  };
}

export const useDepots = () =>
  useQuery<Depot[], Error>({
    queryKey: ["depots"],
    queryFn: async () => {
      const { data } = await api.get<DepotsResponse>("/depots/v1");
      return data.data.depots;
    },
    staleTime: 5 * 60 * 1000, // cache for 5 mins
  });
